<template>
  <v-row justify="space-between" align="center" class="ma-0">
    <v-breadcrumbs :items="crumbs" divider="/"></v-breadcrumbs>
    <v-btn icon="mdi-plus" density="comfortable" @click="showModal = true" id="show-modal"></v-btn>
  </v-row>
  <v-row>
    <v-col cols="12" md="12">
      <v-card :elevation="1">
        <v-card-text>
          <v-table>
            <thead>
              <tr>
                <th class="table-heading-text">identifier</th>
                <th class="table-heading-text text-center">residence</th>
                <th class="table-heading-text text-center">valuation</th>
                <th class="table-heading-text text-center">net income</th>
                <th class="table-heading-text text-right">annual yield</th>
              </tr>
            </thead>
            <tbody>
              <tr class="remove-bottom-border" v-for="property in properties.properties" :key="property.id" @click="showEditModal(property )">
                <td class="table-content-text text-left"> {{ property.identifier }}</td>
                <td class="table-content-text text-center">
                  <v-chip v-if="property.is_primary_residence" variant="outlined" size="small">
                    <v-icon size="16">mdi-check</v-icon>
                  </v-chip>
                </td>
                <td class="table-content-text">{{ property.valuation.toLocaleString() }}</td>
                <td class="table-content-text">{{ property.net_income.toLocaleString() }}</td>
                <td class="table-content-text text-right">{{ Number(property.annual_yield).toLocaleString('en-GB', { style: 'percent', minimumFractionDigits:1 }) }}</td>
              </tr>
              <tr class="add-top-border">
                <td></td>
                <td></td>
                <td class="table-heading-text">{{ Number(properties.total_valuation).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</td>
                <td class="table-heading-text">{{ Number(properties.total_net_income).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</td>
                <td class="table-heading-text text-right">{{ Number(properties.total_annual_yield).toLocaleString('en-GB', { style: 'percent', minimumFractionDigits:2 }) }}</td>
              </tr>
            </tbody>
          </v-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>

  <!-- Modals-->
  <PropertyModalPopup :show="showModal" @close="showModal = false"></PropertyModalPopup> <!-- add a new record -->
  <PropertyEditModalPopup :show="showEditModalToggle" :currentRow="selectedRow" @close="showEditModalToggle = false"></PropertyEditModalPopup> <!--edit a record -->

</template>

<script>
import axios from 'axios';
import PropertyModalPopup from './modals/PropertyNewModalPopup.vue';
import PropertyEditModalPopup from './modals/PropertyEditModalPopup.vue';
import { mapState, mapMutations} from 'vuex';

export default {
  components: {
    PropertyModalPopup,
    PropertyEditModalPopup
  },
  data() {
    return {
      properties: [],
      showModal: false,
      showEditModalToggle: false,
      selectedRow: {}
    };
  },
  async created() {
    this.getProperties();
  },
  computed: {
    ...mapState({
      token: "token"
    }),
    crumbs() {
      return [
        {
          title: 'property assets',
          disabled: true,
          href: ''
        },
      ];
    },

  },
  methods: {
      ...mapMutations(["showSnackbar"]),
    showEditModal(row){
     this.selectedRow=row;
     this.showEditModalToggle = true;
    },
    async getProperties(){
      try {
      const response  = await axios.get("/properties/",
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      });
          this.properties = response.data;
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load properties' });
      }
    }
  }
};
</script>


<style scoped>

table tr{
  cursor: pointer;
}

.table-heading-text{
  font-size: 1.5rem;
  font-weight: 300 !important;
}

.table-content-text{
  font-size: 1.05rem;
  font-weight: 300 !important;
}

.remove-bottom-border td{
  border-bottom: none !important;
}

.add-top-border td{
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}

</style>